import React from "react";
import { Grid, TextField } from "@mui/material";

const FormField = ({
  name,
  label,
  type = "text",
  value,
  onChange,
  required = false,
  min = type === "number" ? 0 : undefined,
  fullWidth = true,
  xs = 12,
  error,
}) => (
  <Grid item xs={xs}>
    <TextField
      fullWidth={fullWidth}
      label={label}
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      required={required}
      inputProps={{ min }}
      error={Boolean(error)}
      helperText={error}
    />
  </Grid>
);

export default FormField;
